import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsConditionsComponent } from './terms-conditions/terms-conditions.component';
import { HotelSearchComponent } from './hotel-search/hotel-search.component';
const routes: Routes = [
	{ 
    path: '',
    loadChildren: () => import('./home/home.module').then(mod => mod.HomeModule),
    data:{ showHeader:true } 
  },
  { 
    path: 'about',
    loadChildren: () => import('./about/about.module').then(mod => mod.AboutModule),
    data:{ showHeader:true }
  },
  { 
    path: 'blogs',
    loadChildren: () => import('./blog/blog.module').then(mod => mod.BlogModule),
    data:{ showHeader:true } 
  },
	{ 
    path: 'hotel/:hotelname',
    loadChildren: () => import('./hotelhome/hotelhome.module').then(mod => mod.HotelhomeModule),
    data:{ showHeader:false } 
  },
	{ 
    path: 'search-results/:hotelname/:room_stay_from/:room_stay_to/:adults/:child',
    loadChildren: () => import('./room-search/room-search.module').then(mod => mod.RoomSearchModule),
    data:{ showHeader:true } 
  },
  { 
    path: 'amenities',
    loadChildren: () => import('./amenities/amenities.module').then(mod => mod.AmenitiesModule),
    data:{ showHeader:true }
  },
  { 
    path: 'manage-bookings',
    loadChildren: () => import('./manage-bookings/manage-bookings.module').then(mod => mod.ManageBookingsModule) ,
    data:{ showHeader:true }
  },
  { 
    path: 'reset-password/:token',
    loadChildren: () => import('./reset-password/reset-password.module').then(mod => mod.ResetPasswordModule) ,
    data:{ showHeader:true }
  },
  { 
    path: 'checkout',
    loadChildren: () => import('./checkout/checkout.module').then(mod => mod.CheckoutModule) ,
    data:{ showHeader:true }
  },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'hotel-search', component: HotelSearchComponent },
  { path:'terms-and-conditions', component:TermsConditionsComponent}

	  
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
